import { render, staticRenderFns } from "./404.vue?vue&type=template&id=58f0e93b&scoped=true"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=58f0e93b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f0e93b",
  null
  
)

export default component.exports